import { useState, useEffect } from 'react';

import { useContextValue } from "../../context/context";
import TimeCounter from "../TimeCounter/TimeCounter";
import DateCounter from "../DateCounter/DateCounter";
import goodIcon from '../../assets/good-icon.svg';
import './style.css';

const AnswerTo = () => {
	const [toTime, setToTime] = useState({ hour: 0, minets: 0 });
	const [toDate, setToDate] = useState({ days: 0, months: 0 });

	const { setAnswerTo } = useContextValue();

	useEffect(() => {
		setAnswerTo((prev) => ({
			...prev,
			date: toDate,
			time: toTime,
		}));
	}, [toDate, toTime, setAnswerTo]);

	return (
		<div className="answerTo">
			<div className="answerTo top">
				<img src={goodIcon} alt="Good" />
				<p>Antwort bis</p>
			</div>
			<div className="answerTo counters">
				<DateCounter fromTo="Datum" date={toDate} setDate={setToDate} />
				<TimeCounter fromTo="Uhrzeit" time={toTime} setTime={setToTime} />
			</div>
		</div>
	)
}

export default AnswerTo;
